define(['jquery'], function searchBar($) {
    "use strict";

    return function searchBar(selector) {

        var $searchBar = $(selector),
            $header = $searchBar.closest('.wrapper'),
            $search = $searchBar.find('.search'),
            $openClose = $search.find('.open-close > button');

        var _onOpenCloseClick;

        _onOpenCloseClick = function _onOpenCloseClick() {
            if ($header.hasClass('search-bar')) {
                $header.removeClass('search-bar');
            } else {
                $header.addClass('search-bar');
            }
            return false;
        };

        $openClose.on('click', _onOpenCloseClick);
    };
});